import { render, staticRenderFns } from "./EWMakePayment.vue?vue&type=template&id=70f95462&"
import script from "./EWMakePayment.vue?vue&type=script&lang=js&"
export * from "./EWMakePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports